import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  useLocation,
} from "react-router-dom";
import WelComePage from "./pages/WelComePage/WelComePage";
import LogoCompo from "./components/LogoCompo/LogoCompo";
import FooterCompo from "./components/FooterCompo/FooterCompo";
import AddReferenceNumberPage from "./pages/AddReferenceNumPage/AddReferenceNumPage";
import GetDetailsPage from "./pages/GetDetailsPage/GetDetailsPage";
import "./styles/globale.scss";
import { ToastContainer } from "react-toastify";
import AddGuestDetails from "./pages/GuestDetails/AddGuestDetails";
import Login from "./pages/Admin/Login/LoginPage";
import Dashboard from "./pages/Admin/Dashboard/Dashboard";
import AdminLayout from "./pages/Admin/AdminLayOut/AdminLayout";
import PastGuest from "./pages/Admin/PastGuest/PastGuest";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import { role } from "./Constants/Constants";
import LastPage from "./pages/LastPage/LastPage";
import { FetchProvider } from "./Context/FetchContext";
import WebPortalLogin from "./pages/Admin/WebPortalLogin/WebPortalLogin";
import WPDashboard from "./components/WpDashboard/WPDashboard";
import WpDashboardStep from "./components/WpDashboardStep_2/WpDashboardStep";
import CurrentGuest from "./pages/Admin/CurrentGuest/Currentguest";
import ViewRecipts from "./pages/Admin/ViewRecipts/VIewRecipts";

const LayOut = () => {
  const location = useLocation();

  return (
    <div className="main">
      <div className="logo-compo">
        <LogoCompo />
      </div>
      <div className="outlet">
        <Outlet />
      </div>
      <div className="footer">
        <FooterCompo />
      </div>
    </div>
  );
};

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <LayOut />,
      children: [
        {
          path: "",
          element: <WelComePage />,
        },
        {
          path: "addreference",
          element: <AddReferenceNumberPage />,
        },
        {
          path: "addreference/:refId",
          element: <AddReferenceNumberPage />,
        },
        {
          path: "getdetails",
          element: <GetDetailsPage />,
        },
        {
          path: "addguestdetails",
          element: <AddGuestDetails />,
        },
        {
          path: "/endpage",
          element: <LastPage />,
        },
      ],
    },
    {
      path: "adminuser",
      element: <Login />,
    },
    {
      path: "adminuser/views",
      element: <PrivateRoute requiredRole={role.admin} />,
      children: [
        {
          path: "",
          element: <AdminLayout />,
          children: [
            { path: "", element: <Dashboard /> },
            { path: "currentguest", element: <CurrentGuest /> },
            { path: "pastguest", element: <PastGuest /> },
            { path: "recipts", element: <ViewRecipts /> },
          ],
        },
      ],
    },
    {
      path: "adminuser/webportal",
      element: <PrivateRoute requiredRole={role.admin} />,
      children: [
        { path: "", element: <WebPortalLogin /> },
        { path: "step_1", element: <WPDashboard /> },
        { path: "step_2", element: <WpDashboardStep /> },
      ],
    },
  ],
  { basename: "/" }
);

function App() {
  return (
    <>
      <ToastContainer />
      <FetchProvider>
        <RouterProvider router={router} />
      </FetchProvider>
    </>
  );
}

export default App;
